
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SpaceLogin from "assets/img/space-login.png";
import { StarDecorations } from "components/ui/StarDecorations";
import { useControlDate } from "hooks/useControlDate";
import { fetchRuleElbb } from "services/rule.service";

function formatDate(d: any): string {
  if (!d) return "";
  const date = new Date(d);
  if (isNaN(date.getTime())) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${day}/${month}`;
}

export function NotFound() {
  const location = useLocation();
  const reason = (location.state as any)?.reason;
  const etapaPreElbb = useControlDate("etapa_pre_elbb");
  const [regulamentoUrl, setRegulamentoUrl] = useState<string | null>(null);

  useEffect(() => {
    if (reason === "nao-habilitado") {
      fetchRuleElbb().then((data: any) => {
        const url = data?.regulation?.url;
        if (url) setRegulamentoUrl(url);
      });
    }
  }, [reason]);

  const dataElbb = etapaPreElbb
    ? `${formatDate(etapaPreElbb.dataInicio)} a ${formatDate(etapaPreElbb.dataFim)}`
    : "";

  const renderContent = () => {
    if (reason === "sem-categoria-elbb") {
      return (
        <>
          <div className="space-y-2 sm:space-y-3 lg:space-y-2 mb-4 sm:mb-5 lg:mb-6">
            <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-pink-bb leading-tight">
              Ops... quase l&aacute;!
            </h1>
            <h2 className="text-xl sm:text-2xl md:text-2xl lg:text-3xl xl:text-4xl font-bold text-yellow-bb leading-tight">
              Você não cadastra iniciativas no Prêmio ELBB.
            </h2>
          </div>
          
          <div className="text-sm sm:text-base md:text-lg lg:text-xl text-white font-medium space-y-4">
            <p className="leading-relaxed">
              O período de inscrição prévia que está acontecendo na semana de {dataElbb}, são das iniciativas do Prêmio ELBB.
            </p>
            
            <p className="leading-relaxed">
              Essa página é para inscrição de iniciativas implementadas por funcionários cedidos às ELBBs: BB Asset, BB-BI, BB Consórcios, BB Seguros e Fundação Banco do Brasil.
            </p>
            <p className="leading-relaxed">
              Mesmo assim, não deixe essa energia de lado!<br />
              Em breve você vai conhecer as iniciativas da ELBB que inspiram e transformam!
            </p>
          </div>
        </>
      );
    }

    if (reason === "nao-habilitado") {
      return (
        <>
          <div className="space-y-2 sm:space-y-3 lg:space-y-2 mb-4 sm:mb-5 lg:mb-6">
            <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-pink-bb leading-tight">
              Ops... quase lá!
            </h1>
            <h2 className="text-xl sm:text-2xl md:text-2xl lg:text-3xl xl:text-3xl font-bold text-yellow-bb leading-tight">
              Você não possui o(s) requisito(s) para<br />
              participação no Prêmio ELBB.
            </h2>
          </div>

          <div className="text-sm sm:text-base md:text-lg lg:text-xl text-white font-medium space-y-4">
            <p className="leading-relaxed font-bold">
              Para mais detalhes, consultar{" "}
              {regulamentoUrl ? (
                <a
                  href={regulamentoUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline text-yellow-bb hover:opacity-80"
                >
                  regulamento da premiação
                </a>
              ) : (
                "regulamento da premiação"
              )}.
            </p>
            <p className="leading-relaxed">
              Mesmo assim, não deixe essa energia de lado!<br />
              Em breve você vai conhecer as iniciativas que inspiram e transformam!
            </p>
          </div>
        </>
      );
    }

    if (reason === "is-gestor") {
      return (
        <>
          <div className="space-y-2 sm:space-y-3 lg:space-y-2 mb-4 sm:mb-5 lg:mb-6">
            <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-pink-bb leading-tight">
              Ops... quase lá!
            </h1>
            <h2 className="text-xl sm:text-2xl md:text-2xl lg:text-3xl xl:text-3xl font-bold text-yellow-bb leading-tight">
              Poderão cadastrar iniciativas no Prêmio ELBB <br />apenas os funcionários de nível técnico. 
            </h2>
          </div>

          <div className="text-sm sm:text-base md:text-lg lg:text-xl text-white font-medium space-y-4">
            <p className="leading-relaxed font-bold">
             Após a etapa de cadastro (pré-inscrição) das iniciativas por funcionários de nível técnico, iniciará a etapa de validação das iniciativas cadastradas. Esta validação será realizada pelo superior imediato do cadastrante.
            </p>
            <p className="leading-relaxed">
             Entidades Ligadas participantes do Prêmio ELBB: BB Asset, BB-BI, BB Consórcios, BB Seguros e Fundação Banco do Brasil.
            </p>
            <p className="leading-relaxed">
              Em breve você vai conhecer as iniciativas que inspiram e transformam!
            </p>
          </div>
        </>
      );
    }

    // Default - layout original
    return (
         <>
          <div className="space-y-2 sm:space-y-3 lg:space-y-2 mb-4 sm:mb-5 lg:mb-6">
            <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-pink-bb leading-tight">
              Ops... quase lá!
            </h1>
            <h2 className="text-xl sm:text-2xl md:text-2xl lg:text-3xl xl:text-3xl font-bold text-yellow-bb leading-tight">
              Você não possui o(s) requisito(s) para<br />
              participação no Prêmio ELBB.
            </h2>
          </div>

          <div className="text-sm sm:text-base md:text-lg lg:text-xl text-white font-medium space-y-4">
            <p className="leading-relaxed font-bold">
              Para mais detalhes, consultar{" "}
              {regulamentoUrl ? (
                <a
                  href={regulamentoUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline text-yellow-bb hover:opacity-80"
                >
                  regulamento da premiação
                </a>
              ) : (
                "regulamento da premiação"
              )}.
            </p>
            <p className="leading-relaxed">
              Mesmo assim, não deixe essa energia de lado!<br />
              Em breve você vai conhecer as iniciativas que inspiram e transformam!
            </p>
          </div>
        </>
    );
  };

  return (
    <div id="notfound-wrapper" className="min-h-screen">
      <div className="relative flex flex-col w-full min-h-screen bg-gradient-to-br from-blue-bb via-blue-bb-1 to-blue-bb-5 overflow-x-hidden">

        <main
          className="flex flex-col lg:flex-row flex-1 items-center justify-center px-4 sm:px-6 md:px-10 lg:px-16 relative gap-8 lg:gap-12"
          role="main"
        >
          <article className="w-full max-w-xl lg:max-w-2xl z-10 text-center lg:text-left">
            {renderContent()}
          </article>

          <aside
            className="hidden lg:flex relative flex-shrink-0 opacity-50"
            aria-hidden="true"
          >
            <img
              src={SpaceLogin}
              alt=""
              className="w-full max-w-md xl:max-w-2xl h-auto object-contain z-20"
              loading="lazy"
              decoding="async"
            />
          </aside>
        </main>

        <div aria-hidden="true" className="hidden md:block pointer-events-none">
          <StarDecorations count={25} density="medium" />
        </div>
      </div>
    </div>
  );
}
